module.exports = "../../static/img/card3.977d56b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/card3.png
// module id = Tr+7
// module chunks = 1